import moment from 'moment';
import React from 'react';
import { Avatar, Col, Collapse, Row } from 'components';
import { Log } from 'models/Log';
import { ArrowBottomIcon } from '../icons/ArrowBottomIcon';
import { ArrowUpIcon } from '../icons/ArrowUpIcon';
import { GreenDotIcon } from '../icons/GreenDotIcon';
import styles from './styles.module.scss';

interface LogItemProps {
  log: Log;
  showVerticalLine: boolean;
  logRef?: (node: Element | null) => void | undefined;
}

export const LogItem: React.FC<LogItemProps> = ({ log, showVerticalLine, logRef }) => {
  const panelStyle: React.CSSProperties = {
    background: '#FCFCFD',
    border: 'none',
  };

  function extractPlainText(input: string): string {
    const hasHTML = /<\/?[a-z][\s\S]*>/i.test(input);

    if (hasHTML) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = input;
      return tempDiv.textContent || tempDiv.innerText || '';
    }

    return input;
  }

  const items = [
    {
      key: log.id,
      label: (
        <Row className={styles.collapse_title}>
          <Col>
            <Avatar src={log?.user?.files?.AVATAR} size="large" className={styles.avatar}>
              {log?.user?.firstName?.charAt(0)}
              {log?.user?.lastName?.charAt(0)}
            </Avatar>
          </Col>
          <Col>
            <strong>{`${log?.user?.firstName || 'Deleted'} ${log?.user?.lastName || 'User'}`}</strong>
            <br />
            <span style={{ textTransform: 'capitalize' }}>{log.title}</span>
          </Col>
        </Row>
      ),
      children: (
        <Row>
          <Col flex={'50px'}></Col>
          <Col>
            <ul className={styles.log_details}>
              <li>Timestamp: {moment(log.createDate).format('DD.MM.YYYY HH:mm:ss')}</li>
              <li>
                Performed By: {log?.user?.firstName} {log?.user?.lastName}
              </li>
              <li style={{ textTransform: 'capitalize' }}>Action Taken: {log.title}</li>
              <li>
                Changes Made:
                <ul className={styles.change_mode}>
                  {log.actions.map((action, index) => {
                    let changeMode: string = '';
                    if (!action.from && action.to) {
                      changeMode = `Added "${extractPlainText(action.to)}"`;
                    } else if (action.from && !action.to) {
                      changeMode = `Deleted "${extractPlainText(action.from)}"`;
                    } else if (action.from && action.to) {
                      changeMode = `Updated from "${extractPlainText(action.from)}" to "${extractPlainText(action.to)}"`;
                    }
                    return (
                      <li key={index + action.propertyName}>
                        {action.propertyName}: {changeMode}
                      </li>
                    );
                  })}
                </ul>
              </li>
            </ul>
          </Col>
        </Row>
      ),
      style: panelStyle,
    },
  ];

  return (
    <Row className={styles.log_item} ref={logRef}>
      <Col span={4} style={{ paddingTop: 13 }}>
        <Row gutter={8}>
          <Col>
            <GreenDotIcon />
          </Col>
          <Col>{moment(log.createDate).format('hh:mmA')}</Col>
        </Row>
        {showVerticalLine && <div className={styles.logs_v_line} />}
      </Col>
      <Col span={20}>
        <Collapse
          bordered={false}
          defaultActiveKey={['1']}
          expandIcon={({ isActive }) => (isActive ? <ArrowUpIcon /> : <ArrowBottomIcon />)}
          expandIconPosition="end"
          items={items}
        />
      </Col>
    </Row>
  );
};
